<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click.native="openDialog"
      >
        <v-icon>add_circle_outline</v-icon>
      </v-btn>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >

        <v-card>
          <v-toolbar
            card
            dense
            color="primary"
          >
            <v-btn
              color="white"
              outline
              @click.native="posttoNav"
            >Post to NAV</v-btn>
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              :loading="isSave"
              icon
              @click.native="saveAndClose"
            >
              <v-icon color="white">library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
              :loading="isSave"
            >
              <v-icon color="white">save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon color="white">add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon color="white">delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon color="white">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon color="white">keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon color="white">keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon color="white">last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="white">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>

            <blister-entry
              ref="eblisterEntryForm"
              v-bind="dialogData"
            ></blister-entry>

          </v-card-text>
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="scrapEntryID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.prodOrderNo }}</td>

        <td class="text-xs-left">{{ props.item.prodLineNo }}</td>
        <td class="text-xs-left">{{ props.item.sourceItemNo }}</td>
        <td class="text-xs-left">{{ props.item.itemDescription }}</td>
        <td class="text-xs-left">{{ props.item.batchNo }}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getPlasticbags, getScrapType, getBlisterScrapEntrys, getBlisterScrapEntry, createBlisterScrapEntry, updateBlisterScrapEntry, deleteBlisterScrapEntry } from '@/api/BlisterScrapEntry';
import BlisterEntry from '@/pages/scrap/BlisterScrapEntry';
import { getProdOrders, postScrapJournal } from '@/api/navService';
import GlobalMessage from '@/constant'
export default {
  components: {
    BlisterEntry,


  },
  data: () => ({
    dialog: false,
    dialogData: null,
    loader: false,
    search: '',
    isSave: false,
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Prod No.', value: 'cardTypeId', align: 'left' },
      { text: 'Prod Line', value: 'cardTypeId', align: 'left' },
      { text: 'Source Item', value: 'itemNo', align: 'left' },
      { text: 'Description', value: 'userName', align: 'left' },
      { text: 'Batch No', value: 'batchNo', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    prodOrders: [],
    plasticbagsitems: [],
    blisterTypeitems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      scrapEntryID: -1,
      date: new Date(),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      prodOrderNo: 1,
      prodLineNo: 1,
      sourceItemNo: '',
      itemDescription: '',
      batchNo: '',
      blisterBom: '',
      plasticBag: -1,
      blisterScrapType: -1,
      plasticBagID: -1,
      blisterScrapTypeID: -1,
      weight: '10',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
    },
    defaultItem: {
      valid: false,
      scrapEntryID: -1,
      date: new Date(),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      prodOrderNo: 1,
      prodLineNo: 1,
      sourceItemNo: '',
      itemDescription: '',
      batchNo: '',
      blisterBom: '',
      plasticBag: -1,
      blisterScrapType: -1,
      plasticBagID: -1,
      blisterScrapTypeID: -1,
      weight: '10',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Blister Scrap' : 'Edit Blister Scrap';
    }
  },

  watch: {
    dialog (val) {

      val || this.close();
    }
  },

  created () {
    this.initialize();
    this.navFunc();
  },

  methods: {
    navFunc () {
      getProdOrders()
        .then(response => {
          this.prodOrders = response.data;
          this.loader = false;
          // console.log(this.prodOrders);
        })
        .catch(() => {
          this.loader = false;
        });
    },
    initialize () {
      this.loader = true;
      getBlisterScrapEntrys('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
          //console.log(this.gridItems);
        })
        .catch(() => {
          this.loader = false;
        });

      getPlasticbags('')
        .then(response1 => {
          this.plasticbagsitems = response1.data;
          this.$refs.eblisterEntryForm.plasticbags = this.plasticbagsitems;
        })
        .catch(() => {

        });

      getScrapType('')
        .then(response2 => {
          this.blisterScrapTypeitems = response2.data;
          this.$refs.eblisterEntryForm.blisterType = this.blisterScrapTypeitems;
        })
        .catch(() => {

        });

    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.$refs.eblisterEntryForm.form = this.editedItem;
      this.dialog = true;
      this.$refs.eblisterEntryForm.prodOrders = this.prodOrders;
      this.$refs.eblisterEntryForm.plasticbags = this.plasticbagsitems;
      this.$refs.eblisterEntryForm.blisterType = this.blisterScrapTypeitems;


    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteBlisterScrapEntry(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    posttoNav () {
      setTimeout(() => {
        window.getApp.$emit('APP_API_SUCCESS', 'Record Posted Successfully to NAV');
        
      }, 600);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {
      getBlisterScrapEntry(this.searchItem)
        .then(response => {
          if (response.data.scrapEntryId != null) {
            this.editedItem = response.data;
            this.$refs.eblisterEntryForm.form = this.editedItem;
            let index = this.gridItems.map(item => item.scrapEntryId).indexOf(response.data.scrapEntryId)
            this.editedIndex = index;
          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No More Record to View');
          }
        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.scrapEntryId;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.scrapEntryId;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.scrapEntryId;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.scrapEntryId;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    openDialog () {
      this.add();
      this.dialog = true;
    },
    add () {

      this.editedItem.scrapEntryId = -1;
      this.valid = false;
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.editedItem.prodOrderNo = null;
      this.editedItem.prodLineNo = null;
      this.editedItem.sourceItemNo = '';
      this.editedItem.itemDescription = '';
      this.editedItem.batchNo = '';
      this.editedItem.blisterBOM = '';
      this.editedItem.plasticBag = null;
      this.editedItem.blisterScrapType = null;
      this.editedItem.plasticBagID = null;
      this.editedItem.blisterScrapTypeID = null;
      this.editedItem.weight = '';
      this.editedItem.addedByUserID = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = null;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();

      this.$refs.eblisterEntryForm.form = this.editedItem;
      this.$refs.eblisterEntryForm.plasticbags = this.plasticbagsitems;
      this.$refs.eblisterEntryForm.blisterType = this.blisterScrapTypeitems;
      this.$refs.eblisterEntryForm.prodOrders = this.prodOrders;

      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deleteBlisterScrapEntry(this.$refs.eblisterEntryForm.form)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    postScrap () {
      postScrapJournal(this.editedItem)
        .then(response => {
          // this.gridItems.push(response.data);
          this.loader = false;
         window.getApp.$emit('APP_API_SUCCESS', 'Record Posted Successfully to NAV');
        
        })
        .catch(error => {
          this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    save () {
      this.editedItem = this.$refs.eblisterEntryForm.form;

      if (this.$refs.eblisterEntryForm.$refs.entryform.validate()) {
        this.loader = true;
        this.isSave = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateBlisterScrapEntry(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
              this.isSave = false;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);

              this.postScrap();
            })
            .catch(error => {
              this.loader = false;             
              this.isSave = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.scrapEntryID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createBlisterScrapEntry(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;              
              this.isSave = false;
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.scrapEntryID).indexOf(response.data.scrapEntryID)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
              this.postScrap();
            })
            .catch(error => {
              this.loader = false;
              this.isSave = false;
             window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterScrapEntryList.vue